import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export default function useQueryParams() {
    const location = useLocation();

    const params = useMemo(() => {
        const previousParams = new URLSearchParams(location.search);
        const paramsMap: Record<string, any> = {};
        previousParams.forEach((value, key) => (paramsMap[key] = value));
        return paramsMap;
    }, [location.search]);

    return params;
}
